import { createFileRoute } from "@tanstack/react-router";
import { LedReminderPage } from "@/pages/LedReminder/LedReminderPage";

// Définition de la route pour la page LedReminder
export const Route = createFileRoute("/ledReminder")({
  component: LedReminderPage,
});
